<!-- src/app/components/home/home.component.html -->
<div class="min-h-screen flex flex-col items-center justify-center bg-gray-100 p-6">
  <div class="max-w-2xl bg-white shadow-lg rounded-lg p-8 text-center">
    <h1 class="text-3xl font-bold text-blue-600 mb-4">CAPTCHA POC</h1>
    <p class="text-gray-700 mb-6">
      This is a Proof of Concept using Google reCAPTCHA v3 integrated into an Angular + Node.js full stack.
    </p>
    <ul class="text-left list-disc list-inside text-gray-600 space-y-2">
      <li>✅ Google reCAPTCHA v3 on Signup/Login/Referral</li>
      <li>✅ Score verification on backend with NodeJs</li>
      <li>✅ IP rate limiting (Node.js middleware)</li>
      <li>✅ Tailwind UI integration</li>
    </ul>
    <div class="mt-8 flex flex-col items-start justify-start">
      <h3 class="text-1xl font-bold text-blue-600 mb-4">
        Pricing: <span class="text-red-500">Enterprise Plan</span>
      </h3>
      <a href="https://cloud.google.com/security/products/recaptcha#pricing" target="_blank" class="text-blue-500 underline">
        Google reCAPTCHA Pricing
      </a>
      <a href="https://pickmysolar.atlassian.net/wiki/spaces/~203152281/pages/1534328864/Google+reCaptcha+V3" target="_blank" class="text-blue-500 underline mt-2">
        POC Details
      </a>
    </div>

  </div>
</div>
